import { useConnectCredentialsStore } from './connectCredentialsStore';
import { useAppSessionStore } from './appSessionStore';
import { useSessionStore } from './sessionStore';

/**
 * Clears every part of the user's session — AcceoConnect credentials, the app session, and the
 * session metadata — across the three concern-scoped stores. Used on sign-out and portal sign-out.
 */
export function clearSession(): void {
    useConnectCredentialsStore.getState().clearConnectCredentials();
    useAppSessionStore.getState().clearAppSession();
    useSessionStore.getState().clearSessionMeta();
}
